import _ from 'lodash';
import AppConstatnt from '../../../../config/app.constants';

class TankersController {
  /*@ngInject*/
  constructor(Auth, $state, User, $scope, RouteService, $translate, LocationService, DataCounter, $q, Modal, BranchService, TransactionService, DateUtil, SetupService, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.DataCounter = DataCounter;
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.TransactionService = TransactionService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$rootScope = $rootScope;
    this.model = {
      tanker: {
        data: ''
      },
      search: "",
      branch: this.User.getUser().branchId,
      dateRange: {
        startDate: null,
        endDate: null
      },

      // date range picker for Tanker tab
      dateRangPickerOptions: {}

    }
    this.stats = {
      currentContents: 'currentContents',
      contentsHistory: 'contentsHistory'
    }
    this.currentStats = 'currentContents';
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.routes = [];
    this.allRoutes = [];
    this.branches = [];
    this.tankerData = [];
    this.tankersData = [];
    this.currentTankersData = [];
    this.totalCurrentTanker = 0;
    this.routeData = [];
    this.tankers = [];
    this.lastScanned = "";
    this.currentVaultDate = "";
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/tankers');
  }

  // get only TANKER data
  loadTanker(searchKey, offset) {
    searchKey = searchKey || '';
    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'locationType',
          condition: '=',
          data: 'TANKER'
        },
        {
          field: 'branchId',
          condition: '=',
          data: this.User.getUser().branchId
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey + '%'
            },
            {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey + '%'
            }
            ],
            operator: 'OR'
          }
        }
        ],
        operator: 'AND'
      }
    };

    this.LocationService.getAllLocation(searchObj, offset, AppConstatnt.defaultPageLimit).then(data => {

      if (offset === 0 || offset == undefined) {
        this.totalTanker = data.total
        this.tankers = this.mapData(data.results);
      } else {
        const tankers = this.mapData(data.results);
        this.tankers = this.tankers.concat(tankers);
      }
    })
  }

  mapData(arrayObj) {
    return arrayObj.map((obj) => {
      return {
        Key: obj.id + ' | ' + obj.name,
        Value: obj.id
      }
    });
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  // do not allow to paste string into datepicker
  dontAllow(element) {
    element.on('cut copy paste', function (event) {
      event.preventDefault();
    });
  }

  setDateRange(date) {
    let currentVaultDate = moment(date).format() || moment();
    this.model.dateRangPickerOptions = {
      autoApply: true,
      // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
      eventHandlers: {
        'apply.daterangepicker': () => {
          if (this.currentStats == 'currentContents') {
            this.pagination.page = 1;
            this.loadCurrentContent()
          } else if (this.currentStats == 'contentsHistory') {
            this.pagination.page = 1;
            this.loadDataOfTankersHistory(this.model.dateRanges);
          }
        }
      },
      ranges: {
        'Today': [
          moment(currentVaultDate).format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Week': [
          moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Month': [
          moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ]
      }
    }
  }

  $onInit() {
    this.$q.all([
      // this.RouteService.all(null, 0, 1000),
      // this.BranchService.all(null, 0, 1000),
      this.SetupService.get(this.User.getUser().branchId),
    ])
      .then((data) => {
        // const routes = data[0].results;
        // const branches = data[1].results;
        // this.branches = branches;
        this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
        this.setDateRange(this.currentVaultDate);
        this.model.dateRange.startDate = moment(this.currentVaultDate).format('YYYY-MM-DD 00:00:00');
        this.model.dateRange.endDate = moment(this.currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');

      })
      .then(() => {
        this.loadPermission();
        if (this.currentStats == 'currentContents') {
          this.loadTanker('', 0);
        } else if (this.currentStats == 'contentsHistory') {

        }
      })
      .catch((err) => {
        console.log(err);
      })

    this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
    this.model.noItemDisplay = true;
    this.model.isError = true;
  }

  // branchChanged() {
  //   this.tankerData = this.tankers.filter((shipments) => {
  //     if (shipments.branchId == this.User.getUser().branchId) {
  //       return shipments.branchId === this.User.getUser().branchId;
  //     }
  //     else {
  //       this.model.noItemDisplay = true;
  //       this.tankersData = [];
  //       this.model.tanker.data = "";
  //     }
  //   })
  //   this.loadTanker('', 0);
  // }
  pageChange() {
    if (this.currentStats == 'currentContents') {
      this.loadCurrentContent()
    } else if (this.currentStats == 'contentsHistory') {
      this.loadDataOfTankersHistory(this.model.dateRanges);
    }
  }

  generateSearchObjs() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'tranType',
            condition: '!=',
            data: null
          },
          {
            group: {
              rules: [
                {
                  field: 'fromLocationId',
                  condition: '=',
                  data: this.model.tanker.data.Value
                },
                {
                  field: 'toLocationId',
                  condition: '=',
                  data: this.model.tanker.data.Value
                },
              ],
              operator: 'OR',
            }
          }
        ],
        operator: 'AND'
      }
    };

    if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
      searchObj.queryJSON.rules.push({
        field: 'transactionDate',
        condition: 'BETWEEN',
        data: [moment(this.model.dateRange.startDate).format('YYYY-MM-DD 00:00:00'), moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')]
      });
    }
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  // Get data of Tanker
  loadDataOfTankersHistory() {
    if (this.model.tanker.data && this.model.tanker.data.Value) {
      const searchObj = this.generateSearchObjs();
      this.model.loading = true;

      if (this.model.tanker.data.Value != this.lastScanned) {
        this.pagination.page = 1;
      }

      return this.TransactionService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
        .then((data) => {
          if (data.results.length) {
            this.pagination.total = data.total;
            this.lastScanned = this.model.tanker.data.Value;
            this.pagination.loading = false;
            this.tankersData = data.results;
            this.model.isError = false;
            this.model.noItemDisplay = false;
            this.localDateTime = moment(this.currentVaultDate).format('MM-DD-YYYY');
            this.isTanker = true;
          }
          else {
            this.model.noItemDisplay = true;
            this.model.messages = this.$translate.instant('error.branch_mgmt.tanker_found');
            this.tankersData = [];
          }
        })
        .catch((err) => {
          console.log(err);
          this.error = err.message;
        })
        .finally(() => {
          this.model.loading = false;
        });
    } else {
      this.tankersData = [];
      this.model.messages = false;
      this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
      this.model.noItemDisplay = true;
      this.model.isError = true;
    }
  }

  tabSelection(selectedValue) {
    if (selectedValue == 'currentContents') {
      this.pagination.page = 1;
      this.loadCurrentContent()
    } else if (selectedValue == 'contentsHistory') {
      this.pagination.page = 1;
      this.loadDataOfTankersHistory()
    }
    this.currentStats = selectedValue;
  }

  loadCurrentContent() {
    if (this.model.loading) return;
    if (this.model.tanker.data && this.model.tanker.data.Value) {
      this.model.loading = true;

      if (this.model.tanker.data.Value != this.lastScanned) {
        this.pagination.page = 1;
      }
      let filter = {}
      filter.locationId = this.model.tanker.data.Value;

      if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
        filter.transactionDate = {
          start: moment(this.model.dateRange.startDate).format('YYYY-MM-DD'),
          end: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD')
        }
      }

      return this.TransactionService.currentContent(filter, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
        .then((data) => {
          if (data.result.length) {
            this.pagination.total = data.total;
            this.lastScanned = this.model.tanker.data.Value;
            this.currentTankersData = data.result;     
            this.totalCurrentTanker = data.total;
            this.model.isError = false;
            this.model.noItemDisplay = false;
            this.localDateTime = moment(this.currentVaultDate).format('MM-DD-YYYY');
            this.pagination.loading = false;
          } else {
            this.model.noItemDisplay = true;
            this.model.messages = this.$translate.instant('error.branch_mgmt.tanker_found');
            this.currentTankersData = [];
            this.totalCurrentTanker = 0;
          }
        })
        .catch((err) => {
          console.log(err);
          this.error = err.message;
        })
        .finally(() => {
          this.model.loading = false;
        });
    } else {
      this.currentTankersData = [];
      this.totalCurrentTanker = 0;
      this.model.messages = false;
      this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
      this.model.noItemDisplay = true;
      this.model.isError = true;
    }
  }
  browserTZ() {
    return moment.tz.guess();
  }
  
  getLocalTime() {
    return moment().format('hh:mm A')
  }
  printTankerContent() {
    const obj = {
      selectedValue: this.model.tanker.data.Value,
      dateRange: this.model.dateRange,
      limit:  this.totalCurrentTanker
    };
    const path = this.$state.href('printTankers');
    window.w = window.open(path, '_blank');
    window.w.printData = obj;
  }

  goToItemHoldTab(trackingId) {
    const obj = {
      trackingId: trackingId,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.itemHolds');
  }

  goToServiceHistory(locationId) {
    const obj = {
      locationId: locationId,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.locations');
  }

  translateTranType(tranType) {
    if (!tranType) return;
    return this.$translate.instant(`shipment.${tranType}`).toUpperCase();
  }

  goToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

}

export default TankersController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/tankers.controller.js